const Features = () => {
    return (


        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="text-primary">Methodology overview</h6>
                    <h1 className="mb-4">SARSYS-CAD software for strength and reliability analysis</h1>
                </div>
                <div className="row g-2">
                    <p className="mb-2">"Fatigue analysis software will become more widely adopted as it becomes further integrated with CAD packages," Professor Irving says (Autodesk).</p>
                    <p className="mb-2 pb-2 center">STEDAX Inc. developed several versions of strength analysis on the KTSM basis. </p>
                    <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="service-item rounded overflow-hidden">
                            <br></br>
                            <div className="position-relative p-4 pt-0">
                                <h4 className="mb-4">Note 1</h4>
                                <p>According KTSM approach there are no terms of “static strength” and “fatigue strength”. In KTSM there is definition only “strength of the material”.</p>
                                <a className="small fw-medium" href="">Read More<i
                                    className="fa fa-arrow-right ms-2"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-4 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="service-item rounded overflow-hidden">
                            <br></br>
                            <div className="position-relative p-4 pt-0">
                                <h4 className="mb-4">Note 2</h4>
                                <p>SARSYS-CAD is a system of decoding of physical parameters of materials, converting them in numerical form and then in graphical form of software for strength analysis.</p>
                                <a className="small fw-medium" href="">Read More<i
                                    className="fa fa-arrow-right ms-2"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
                        <div className="service-item rounded overflow-hidden">
                            <br></br>
                            <div className="position-relative p-4 pt-0">
                                <h4 className="mb-4">Note 3</h4>
                                <p>STEDAX operates by real physical parameters instead any hypotheses, assumptions and simulations.</p>
                                <a className="small fw-medium" href="">Read More<i
                                    className="fa fa-arrow-right ms-2"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="service-item rounded overflow-hidden">
                            <br></br>
                            <div className="position-relative p-4 pt-0">
                                <h4 className="mb-4">Note 4</h4>
                                <p>Regarding strength degradation and damage accumulation: KTSM Rule 2: ∑ni/N = ∑di/D =1 but ni/N ≠ di/D.</p>
                                <a className="small fw-medium" href="">Read More<i
                                    className="fa fa-arrow-right ms-2"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="service-item rounded overflow-hidden">
                            <br></br>
                            <div className="position-relative p-4 pt-0">
                                <h4 className="mb-4">Note 5</h4>
                                <p>The block regime of the loading determined by standard RainFlow method cannot be equivalent in principle.</p>
                                <a className="small fw-medium" href="">Read More<i
                                    className="fa fa-arrow-right ms-2"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="service-item rounded overflow-hidden">
                            <br></br>
                            <div className="position-relative p-4 pt-0">
                                <h4 className="mb-4">Note 6</h4>
                                <p>The nCODE’s “DesignLife” area of application is Fatigue Analysis only. SARSYS-CAD is applicable at all stage of structural life from design to operation.</p>
                                <a className="small fw-medium" href="#SARSYS-CAD">Read More<i
                                    className="fa fa-arrow-right ms-2"></i></a>
                            </div>
                        </div>
                    </div>
                    <p className="mb-0 pb-2">SARSYS-CAD is a complex system of strength analysis on the all stages of the structure: design, production, certification test, structural strength monitoring and individual life prediction on the operation stage.</p>
                </div>
            </div>
        </div>

    )
}

export default Features;